<template>
  <div>
    <CancelSubscriptionModalStepOne
      v-if="step === 1"
      :next="goToStepTwo"
      :is-ltrs="isLtrs"
      :service-id="serviceId"
    />
    <CancelSubscriptionModalStepTwo v-if="step === 2" :next="cancelService" />
    <CancelSubscriptionModalStepThree v-if="step === 3" :title="title" :messages="messages" />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import _ from 'lodash';
import VueTypes from 'vue-types';
import { lsScheduleHelpers } from '../../helpers';
import { API_SCHEDULE_FINAL_STATUSES } from '../../constants';
import CancelSubscriptionModalStepOne from './components/CancelSubscriptionModalStepOne.vue';
import CancelSubscriptionModalStepTwo from './components/CancelSubscriptionModalStepTwo.vue';
import CancelSubscriptionModalStepThree from './components/CancelSubscriptionModalStepThree.vue';
import {
  PROPERTIES__PROPERTIES_IN_ARRAY,
  SCHEDULES__GROUPED_BY_PROPERTY,
  SUPPORT__CANCEL_STANDALONE,
} from '@/store/types';
import { themedComponentMixin } from '@/mixins';

function getCancellationStatus({ property, level, copy, reason }) {
  return {
    class: level === 'success' ? 'is-success' : 'is-warning',
    label: property.street,
    copy: `We're sorry to see you go!${_.get(
      copy,
      reason,
      ''
    )}\n\nThanks again for letting us serve you and we hope to see you back with us soon!`,
  };
}

export default {
  name: 'CancelSubscriptionModal',
  components: {
    CancelSubscriptionModalStepOne,
    CancelSubscriptionModalStepTwo,
    CancelSubscriptionModalStepThree,
  },
  mixins: [themedComponentMixin],
  props: {
    isLtrs: VueTypes.bool.def(false),
    serviceId: VueTypes.number,
  },
  data() {
    return {
      step: 1,
      propertyIds: [],
      messages: [],
    };
  },
  computed: {
    ...mapState(['properties']),
    ...mapGetters([PROPERTIES__PROPERTIES_IN_ARRAY, SCHEDULES__GROUPED_BY_PROPERTY]),
  },
  async created() {
    this.propertyIds = _.map(
      this[PROPERTIES__PROPERTIES_IN_ARRAY],
      (property) => _.get(property, 'id') || _.get(property, 'property_id')
    );
  },
  methods: {
    ...mapActions([SUPPORT__CANCEL_STANDALONE]),
    scrollUp() {
      if (_.get(document.getElementsByClassName('modal-content'), 0)) {
        document.getElementsByClassName('modal-content')[0].scrollTo(0, 0);
      }
    },
    goToStepTwo({ properties }) {
      this.propertyIds = properties;
      this.step = 2;
      this.scrollUp();
    },
    cancelService({
      reason,
      notes,
      plans_to_hire_other_provider,
      satisfaction,
      notes_good,
      notes_improve,
    }) {
      const copy = {
        '3_cut': `\n\nYour services will be canceled after your third cut is completed.\n\nYou don't need to take any more action at this time, but you will still receive your remaining services with ${
          this.brandName
        }.`,
        '48_hours': `\n\nYou'll still receive your next scheduled service since we received your cancellation within 48 hours of your service window.\n\nAfter your service is complete, we'll process your cancellation.`,
      };

      const schedules = _.map(this.propertyIds, (propertyId) =>
        this[SCHEDULES__GROUPED_BY_PROPERTY][propertyId].find((schedule) => {
          const scheduleStatus = _.get(schedule, 'status');
          if (!scheduleStatus) {
            return false;
          }

          if (_.includes(API_SCHEDULE_FINAL_STATUSES, scheduleStatus)) {
            return false;
          }

          return lsScheduleHelpers.getServiceFromSchedule(schedule).id === this.serviceId;
        })
      );

      const scheduleIds = schedules
        .filter((schedule) => schedule !== undefined)
        .map((schedule) => schedule.id);

      this[SUPPORT__CANCEL_STANDALONE]({
        schedules: scheduleIds,
        reason,
        notes,
        plans_to_hire_other_provider,
        satisfaction,
        notes_good,
        notes_improve,
      }).then((data) => {
        if (data) {
          this.step = 3;
          this.scrollUp();

          this.title = 'Success';
          this.messages = _.map(data.schedules, ({ level, schedule, reason }) => {
            const property = this[PROPERTIES__PROPERTIES_IN_ARRAY].find(
              (property) => property.property_id === schedule.property_id
            );
            if (level !== 'success') {
              this.title = 'Important';
            }

            return getCancellationStatus({ property, level, copy, reason });
          });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
